import styled from 'styled-components';

import Image from '../../Components/Image';

export const BodyContainer = styled.div`
    grid-area: body;
    padding: 15px;
`;

export const CalendarIcon = styled(Image)`
    height: 25px;
`;

export const ChartDateCustomContainer = styled.div`
    align-items: center;
    border: 2px solid ${props => props.Selected ? 'var(--blue-abel)' : 'var(--white-concrete)'};
    border-radius: 10px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 5px 10px;

    @media(hover:hover) {
        :hover {
            border-color: var(--blue-abel);
            cursor: pointer;
        }
    }
`;

export const ChartDateCustomTextContainer = styled.div`
    margin-right: 10px;
`;

export const ProductTable = styled.div``;

export const ProductTableBody = styled.div``;

export const ProductTableBodyColumn = styled.div``;

export const ProductTableBodyRow = styled.div``;

export const ProductTableHeader = styled.div``;

export const ProductTableHeaderColumn = styled.div``;